enum FieldType {
  String = "string",
  DateTime = "datetime-local",
  Project = "project",
  Model = "model",
  MessageType = "message-type",
}

export default FieldType;
